import { createFileRoute, Link, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/sample/_layout')({
  component: () => (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <div
        style={{
          padding: '15px',
          background: '#f0e8f8',
          borderRadius: '8px',
          marginBottom: '20px',
          border: '2px solid #9c27b0',
        }}
      >
        <h1 style={{ marginBottom: '10px', color: '#333' }}>
          Pathless Layout Route
        </h1>
        <p style={{ marginBottom: '15px', color: '#666', fontSize: '14px' }}>
          URL 경로에 영향을 주지 않으면서 자식들에게 레이아웃을 제공합니다. _
          접두사를 사용합니다.
        </p>
        <nav>
          <Link to="/" style={{ marginRight: '10px', color: '#9c27b0' }}>
            ← 홈으로
          </Link>
          <span style={{ margin: '0 5px', color: '#999' }}>|</span>
          <Link to="/a" style={{ marginRight: '10px', color: '#9c27b0' }}>
            A
          </Link>
          <span style={{ margin: '0 5px', color: '#999' }}>|</span>
          <Link to="/b" style={{ color: '#9c27b0' }}>
            B
          </Link>
        </nav>
      </div>
      <div
        style={{
          padding: '20px',
          background: '#fafafa',
          borderRadius: '8px',
          border: '2px dashed #9c27b0',
        }}
      >
        <div style={{ fontSize: '12px', color: '#999', marginBottom: '10px' }}>
          ↓ 자식 라우트 영역 (Outlet) ↓
        </div>
        <Outlet />
      </div>
    </div>
  ),
});
